export * from './lib/UiProductPictureMain';
export * from './mock';
